<template>
  <el-select v-model="currStyle" size="small" placeholder="请选择">
    <el-option
      v-for="item in styleList"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
<!--   <a-select style="width: 120px" v-model="currStyle">
    <a-select-option v-for="s in styleList" :value="s.value">{{s.label}}</a-select-option>
  </a-select> -->
</template>

<script>
import {map_theme} from '@/options/theme'

export default{
  data(){
		return{
      currStyle: 'normal',
      styleList: [
        {label: '默认样式', value: 'normal', type: 'string'},
        {label: '深蓝(推荐)', value: 'json', data: map_theme, type: 'json'},
        {label: '清新蓝', value: 'light', type: 'string'},
        {label: '黑夜', value: 'dark', type: 'string'},
        // {label: '红色', value: 'redalert'},
        {label: '精简', value: 'googlelite', type: 'string'},
        // {label: '自然绿', value: 'grassgreen'},
        {label: '午夜蓝', value: 'midnight', type: 'string'},
        // {label: '浪漫粉', value: 'pink'},
        // {label: '青春绿', value: 'darkgreen'},
        // {label: '清新蓝绿', value: 'bluish'},
        // {label: '高端灰', value: 'grayscale'},
        {label: '强边界', value: 'hardedge', type: 'string'}
      ]
		}
	},
  props:[
    'map'
  ],
  mounted(){
    // var style = localStorage['map_style']
    // if (style){
    //   this.currStyle = style
    // }
    // this.$store.commit("setCurrMapStyle", this.currStyle)
  },
  watch:{
    currStyle(){
      this.changeStyle()
    },
    // map(){
    //   this.changeStyle()
    // }
  },
	methods:{
		changeStyle(){
      var style_info = _.find(this.styleList, x=>{return x.value == this.currStyle})
      if (!style_info ){
        return
      }
      if (style_info.type == 'json'){
        this.map.setMapStyle(style_info.data);
      }else{
        this.map.setMapStyle({  style : this.currStyle }  );
      }
      localStorage.setItem("map_style", this.currStyle);  
      // this.$emit("changeStyle", this.currStyle)
      this.$store.commit("setCurrMapStyle", this.currStyle)
    }
	}
}
</script>


// WEBPACK FOOTER //
// src/components/mapStyleControl.vue